import React from 'react'

import { Form, Col } from '_zari/core'

import * as UsuarioCrud from 'services/usuario.service'

const IdUsuarioFormGroup = ({ value, onChange }) => {
  const [usuarios, setUsuarios] = React.useState([])

  React.useEffect(() => {
    UsuarioCrud.obtenerTodoAsSelect().then(({ data }) => setUsuarios(data))
  }, [])

  return (
    <Form.Group>
      <Form.Label text='USUARIO' htmlFor='select-usuario' md={4} />
      <Col md={8}>
        <Form.Select 
        name="selectUsuario"
        value={value} onChange={onChange} id='select-usuario'>
          <option value=''>Seleccionar</option>
          {usuarios &&
            usuarios.map((val, key) => (
              <option key={key} value={val._id}>
                {val.username}
              </option>
            ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdUsuarioFormGroup)
